import { DonBalance } from '~/components/Balance';
import don from '~/components/Icon/simpleDon.png';
import { useMember } from '~/components/Member/Member.hooks';
import { QuickMenuItem, QuickMenuItemProps } from '~/components/Quick/Menu/QuickMenuItem';
import { abbreviate } from '~/components/Util/number';

export type DonQuickMenuItem = Partial<QuickMenuItemProps>;

export const DonQuickMenuItem = (props: DonQuickMenuItem) => {
  const {
    data: { isLoggedIn },
  } = useMember();

  return (
    <QuickMenuItem
      image={don}
      label="DON"
      description={isLoggedIn && <DonBalance format={abbreviate} />}
      {...props}
    />
  );
};
